export default "__VITE_ASSET__DM1DoyBW__"